/**
 * updateUserProfile module
 * Checks for the user credentials which may have expired or not exist
 * then updates the user profile item containing the App's current lists
 * and notification settings in DynamoDB
 */

import appConstants from '../constants/appConstants';
import checkCredentials from '../authentication/checkCredentials';
import store from '../reducers/store';

function updateUserProfile(fieldName, fieldObject) {
  return new Promise((resolve, reject) => {
    checkCredentials().then((cognitoUser) => {
      let id = '';
      let username = '';

      if (store.getState().main.displayedUser == '') {
        username = localStorage.zmailUsername;
        id = localStorage.zmailUserId;
      } else {
        username = store.getState().main.displayedUser.split('_')[0];
        id = store.getState().main.displayedUser.split('_')[1];
      }

      const docClient = new AWS.DynamoDB.DocumentClient();
      const userId = username + '-us-east-1:' + id;

      var params = {
        TableName: appConstants.USER_TABLE,
        Key: { id: userId },
        UpdateExpression: 'SET #fN = :fO',
        ExpressionAttributeNames: {
          '#fN': fieldName,
        },
        ExpressionAttributeValues: {
          ':fO': fieldObject,
        },
      };

      docClient
        .update(params)
        .promise()
        .then(() => {
          resolve();
        })
        .catch((err) => {
          console.log(err, err.stack);
          reject(err);
        });
    });
  });
}

export default updateUserProfile;



// WEBPACK FOOTER //
// ./src/userFunctions/updateUserProfile.js